const STORAGE_KEY_CART_ITEM_LENGTH = "cartLength";
const STORAGE_KEY_CART_ITEM_IDS = "bagId";
const STORAGE_KEY_BUY_ITEM_IDS = "buy";

export function saveCartItemLength(cartItemLength) {
  window.localStorage.setItem(STORAGE_KEY_CART_ITEM_LENGTH, cartItemLength);
}

export function loadCartItemLength() {
  return window.localStorage.getItem(STORAGE_KEY_CART_ITEM_LENGTH);
}

export function removeCartItemLength() {
  window.localStorage.removeItem(STORAGE_KEY_CART_ITEM_LENGTH);
}

export function saveCartItems(cartIds) {
  window.localStorage.setItem(STORAGE_KEY_CART_ITEM_IDS, cartIds);
}

export function loadCartItems() {
  return window.localStorage.getItem(STORAGE_KEY_CART_ITEM_IDS);
}

export function removeCartItems() {
  window.localStorage.removeItem(STORAGE_KEY_CART_ITEM_IDS);
}

export function saveBuyItems(buyItems) {
  window.localStorage.setItem(STORAGE_KEY_BUY_ITEM_IDS, buyItems);
}

export function loadBuyItems() {
  return window.localStorage.getItem(STORAGE_KEY_BUY_ITEM_IDS);
}

export function removeBuyItems() {
  window.localStorage.removeItem(STORAGE_KEY_BUY_ITEM_IDS);
}
